import React from "react";
import logo from "../assets/images/Group 575.svg"; // correct import path

const PopupScreen = ({ closePopup }) => {
  
  const handelclick =()=>{
closePopup();
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "grid",
        placeItems: "center",
        zIndex: 999,
      }}
    >
      <div
        style={{
          width: "210px",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          textAlign: "center",
          position: "absolute",
          top: "90px",
          height: "210px",
        }}
      >
    

        <div>
          <img src={logo} alt="Logo"  style={{width:'60px'}}/>
        </div>
       
        <div>
            <h4 style={{fontSize:'16px', color:'#333333', marginBottom:'20px', marginTop:'10px'}}>All Set!</h4>
            <p style={{fontSize:'14px', color:'#666666'}}>You’re all set! Let’s make today<br></br>productive.🚀 </p>
            <button style={{width:'130px', height:'37px', borderRadius:'5px',backgroundColor:'#2196F3', color:'#fff',padding:'10px', border:'none', marginTop:'17px'}} onClick={handelclick}>Start Using App</button>
        </div>
      </div>
    </div>
  );
};

export default PopupScreen;
